class localStorage {
    ls = window.localStorage
  
    setItem(key, value) {
      value = JSON.stringify(value)
      this.ls.setItem(key, value)
      return true
    }
  
    getItem(key) {
      const value = this.ls.getItem(key)
      try {
        return JSON.parse(value)
      } catch (e) {
        return null
      }
    }
  
    clear() {
      this.ls.clear()
    }
  }
  
  export default new localStorage()
  